export default __webpack_public_path__ + "static/media/1388.67d6ebe8.png";